<template lang='pug'>
  v-dialog(v-model='dialog' scrollable persistent max-width='80%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }}
      v-card-text
        v-container
          v-row(dense)
            v-col(cols='12')
              v-card(color='white')
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-text-field#nombreCliente(v-model='form.nombre' persistent-hint outlined readonly  label='Nombre'  dense)
                    v-col(cols='12' sm='12' md='12')
                      v-data-table.elevation-1(:headers='headers'  :items='fac2' :search='search' :loading='loading' loading-text='Cargando, por favor espere...')
                        template(v-slot:top)
                          v-toolbar(flat color='primary' dark)
                            v-toolbar-title Facturas
                            v-divider.mx-4(inset vertical)
                            v-spacer
                            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
                            v-spacer
                            PagoFacturaClienteM(:dialog='dialog2' @close='dialog2=false' :FormPadre='facturaPag' :pagos='facturaPag.pagos', :productos="facturaPag.detalleProducto")
                            NotaCreditoM(:dialog='dialog3' @close='dialog3=false; facturaPag={}; fac2 = facturas' :FormPadre='facturaPag', :factura="numFacturaCli", :productos="facturaPag.detalleProducto" @save='listarNotasCredito' @venta='actualizarVenta')
                        template(v-slot:item.action='{ item }')
                          v-tooltip(bottom='')
                            template(v-slot:activator='{ on }')
                              v-icon.mr-2(color='primary_2' @click='editItem(item, false)' v-on="on") mdi-format-list-checkbox
                            | Pagos Asociados
                          v-tooltip(bottom='')
                            template(v-slot:activator='{ on }')
                              v-icon.mr-2(color='error' @click='editItem(item, true)' v-on="on") mdi-undo-variant
                            | Nota de Credito
                        template(v-slot:no-data)
                          h1 No hay Facturas Asociadas
                  v-row(class='d-flex justify-end')
                    v-col(cols='12' sm='12' md='3')
                      v-text-field(dense readonly outlined :value='credito | read', label='Total Credito')
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
</template>

<script>
import Api from '@/services/methods'
import PagoFacturaClienteM from '@/components/modals/PagoFacturaClienteM'
import NotaCreditoM from '@/components/modals/NotaCreditoM'
export default {
  props: ['dialog', 'FormPadre', 'facturas', 'credito'],
  data: () => ({
    loading: true,
    dialog2: false,
    dialog3: false,
    search: '',
    numFacturaCli: 0,
    notasCredito: [],
    facturaAnterior: {},
    headers: [
      { text: 'Factura', align: 'left', value: 'numFactura' },
      { text: 'Fecha de creación', value: 'fechaCreacion' },
      { text: 'Fecha de vencimiento', value: 'fechaVencimiento' },
      { text: 'Vendedor', value: 'idPedido.idUsuario.nombre' },
      { text: 'Monto Total', value: 'total' },
      { text: 'Días Deuda', value: 'moroso' },
      { text: 'Debito', value: 'debito' },
      { text: 'Credito', value: 'credito' },
      { text: 'Tipo de Venta', value: 'tipoVenta' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    pagos: [],
    facturaPag: {},
    fac2: [],
    form: {},
    form2: {}
  }),
  components: {
    PagoFacturaClienteM,
    NotaCreditoM
  },
  computed: {
    formTitle () {
      return 'Facturas Asociadas'
    }
  },
  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
      }
      this.fac2 = this.facturas
    },
    dialog3: function (val) {
      if (!val) {
        let i = this.facturas.findIndex(
          fac => fac._id === this.facturaAnterior._id
        )
        this.facturas[i] = this.facturaAnterior
      }
    },
    facturas: function (val) {
      this.fac2 = val
    }
  },

  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.listarPagos()
      this.listarNotasCredito()
    },

    encontrarFac (factura) {
      return factura._id === this.facturaAnterior._id
    },

    listarPagos () {
      Api.get('/pago')
        .then(response => {
          this.pagos = response.data
          this.pagos.map(data => {
            data.fechaCobro = this.formato(data.fechaCobro)
            data.fechaRegistro = this.formato(data.fechaRegistro)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    listarNotasCredito () {
      Api.get('/notacredito')
        .then(response => {
          this.notasCredito = response.data
          this.loading = false
          this.notasCredito.map(data => {
            data.fechaCreacion = this.forma2(data.fechaCreacion)
            data.fechaVencimiento = this.forma2(data.fechaVencimiento)
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    forma1 (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD')
    },

    forma2 (fecha) {
      return this.$moment(fecha).format('DD-MM-YYYY')
    },

    formato (fecha) {
      return this.$moment(fecha).format('DD-MM-YYYY, HH:mm')
    },

    decimal (val) {
      return Number.parseFloat(val).toFixed(2)
    },

    facturaPago (factura) {
      let pag = []
      this.facturaPag = factura
      this.numFacturaCli = factura.numFactura
      this.pagos.map(data => {
        if (factura._id === data.idVenta._id) {
          pag.push(data)
        }
      })
      this.facturaPag.pagos = pag
    },

    facturaNotaCredito (factura) {
      this.form2 = factura
      let bool = true
      this.notasCredito.map(nota => {
        if (nota.numFactura === factura.numFactura) {
          if (nota.idTipoNotaCredito.descripcion === 'DEVOLUCION TOTAL') {
            this.$swal({
              icon: 'error',
              title: 'Factura Devuelta',
              text: 'No puede realizar una nota de crédito a esta factura'
            })
            bool = false
          } else if (
            nota.idTipoNotaCredito.descripcion === 'DEVOLUCION PARCIAL') {
            nota.detalleProducto.map(notaPro => {
              factura.detalleProducto.map(facPro => {
                if (notaPro.idProducto._id === facPro.idProducto._id) {
                  facPro.despachada -= notaPro.devuelto
                }
              })
            })
          }
        }
      })
      return bool
    },

    actualizarVenta () {
      this.$emit('act')
    },

    editItem (item, bool) {
      this.facturaAnterior = item
      this.facturaPago(item)
      if (bool) {
        if (this.facturaNotaCredito(item)) {
          this.dialog3 = true
        }
      } else {
        this.dialog2 = true
      }
    },

    close () {
      setTimeout(() => {
        this.facturaPag = {}
        this.form = Object.assign({}, this.defaultItem)
      }, 300)
      this.$emit('close')
    }
  }
}
</script>
